// extracted by mini-css-extract-plugin
export var cardSt = "single-card-module--cardSt--1Bj9V";
export var imgOverflow = "single-card-module--imgOverflow--1Wp2i";
export var CardImgSt = "single-card-module--CardImgSt--1VG_-";
export var timeSt = "single-card-module--timeSt--18PyG";
export var postTitle = "single-card-module--postTitle--VdkFT";
export var textSt = "single-card-module--textSt--1mizR";
export var readMore = "single-card-module--readMore--2KJ_J";